export default "__VITE_ASSET__DVO4Kc7T__"